const config = {
  ssoUrl: 'https://quality.bigroad.com/partner-sign-in/freight', // UPDATE WHEN AVAILABLE
};

export default config;
